<app-action-button *ngIf="!hideClose" [facet]="'secondary'" [size]="'small'" (action)="close()">
  {{ 'shared.common.close' | translate }}
</app-action-button>

<ng-content></ng-content>
